import { IConfig } from 'configs/config.interface'

export const CONFIG: IConfig = {
	Type: 'uat',
	API: {
		ContainerTracking:
			'https://afcazewumlns011finops.azurewebsites.net/containertracking/api',
		Customs: 'https://afcazewumlns011finops.azurewebsites.net/customs/api',
		DeliveryPlanning:
			'https://afcazewumlns011finops.azurewebsites.net/deliveryplanning/api',
		Apigee: 'https://api-uat.maersk.com/scm/v1/finops',
		Uaminfo: 'https://api-uat .scm.maersk.com/finance',
		ViewPdf: 'https://api-uat.maersk.com',
		FrontDoor: 'https://api-uat.scm.maersk.com/finance',
		ApiCode: 'kxPaEvRO4yjrJb7PV0zZ7aEL4Ir1SCNauBLVjg7wi115c7hklQiSnw==',
		ApiKey: 'kFcbqDBk9O45T+ouLY3F0N63qD2qt17+0/RWz90KmmE=',
		FeatureManagementURL: 'https://api-uat.scm.maersk.com/feature-management/functions/FINOPS/features',
	},
	FunctionCode: 'APIFUNC',
	graphScope: 'https://graph.microsoft.com/User.Read',
	isDataDOGEnabled: 'true',
	dataDogENV: 'ewu',
	dataDogApplicationId: 'd4077f26-0c5f-42ef-b51a-855bf175a037',
	dataDogClientToken: '',
	consumerKey: 'GgnNlO1zCUfJTMWzScfbrQnti9jkatZy',
	walkMe: 'https://cdn.walkme.com/users/5be6ef69cb6d4406a12e152f40b267d3/test/walkme_5be6ef69cb6d4406a12e152f40b267d3_https.js',
	MSAL: {
		instance: 'https://login.microsoftonline.com',
		tenant: 'maersk.onmicrosoft.com',
		signInPolicy: '',
		applicationId: '22eb3953-7e1a-4c33-ac02-86047493f8de',
		cacheLocation: 'sessionStorage',
		scopes: ['https://maersk.onmicrosoft.com/finops-api-preprod/user_impersonation'],
		redirectUri: 'https://finops-uat.cs.scm.maersk.com/',
		postLogoutRedirectUri: 'https://finops-uat.cs.scm.maersk.com/',
		storeAuthStateInCookie: true,
	},
	MOP_APP_NAME: 'Damco-Finops-Ui-uat',
    MOP_API_KEY: 'O1AcKLvYjO+BsCeLl6shiNKYxAbQDCQdLGhyobC4GE6h/YrDhWZ8ZveMAPdYlg==',
}
